"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStreams = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../../../../utils");
var flip_bit_matrix_1 = require("../../../functions/bit-matrix/flip-bit-matrix");
var bit_matrix_1 = require("../../../types/record/bit-matrix");
var positive_points_reducer_1 = require("../../functions/positive-points-reducer");
var useStreams = function (open$, imgSrc$, cropRectRelative$, backgroundOfPaintObjectsCropped$, plotMode$, plotRelative$) {
    var imgPixelSize$ = (0, utils_1.useDataStream)((0, utils_1.IRectSize)(), imgSrc$.pipe((0, utils_1.filterNotValue)(''), (0, operators_1.distinctUntilChanged)(), (0, operators_1.mergeMap)(utils_1.getImageSizeFromUrl)));
    var croppedRectPixel$ = (0, utils_1.useDataStream)((0, utils_1.IRect)(), (0, utils_1.combineLatestTyped)(imgPixelSize$, cropRectRelative$).pipe((0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), imgPixelSize = _b[0], cropRectRelative = _b[1];
        return (0, utils_1.roundRectToInt)((0, utils_1.IRect)({
            width: imgPixelSize.width * cropRectRelative.width,
            height: imgPixelSize.height * cropRectRelative.height,
            top: imgPixelSize.height * cropRectRelative.top,
            left: imgPixelSize.width * cropRectRelative.left
        }));
    })));
    var readonlyArea$ = (0, utils_1.useDataStream)((0, bit_matrix_1.IBitMatrix)(), backgroundOfPaintObjectsCropped$.pipe((0, operators_1.map)(flip_bit_matrix_1.flipBitMatrix)));
    var croppedRectAspectRatio$ = (0, utils_1.useDataStream)(1, croppedRectPixel$.pipe((0, operators_1.map)(function (rect) { return rect.width / rect.height; })));
    var positivePointsRelative$ = (0, utils_1.useDataStream)((0, utils_1.IList)(), (0, utils_1.mergeTyped)(plotRelative$.pipe((0, utils_1.filterByLatest)(plotMode$.pipe((0, utils_1.valueIs)('+')))), open$.pipe((0, utils_1.filterValue)(false), (0, utils_1.mapToConst)('close-dialog'))).pipe((0, operators_1.scan)(positive_points_reducer_1.pointsListReducer, (0, utils_1.IList)())));
    var negativePointsRelative$ = (0, utils_1.useDataStream)((0, utils_1.IList)(), (0, utils_1.mergeTyped)(plotRelative$.pipe((0, utils_1.filterByLatest)(plotMode$.pipe((0, utils_1.valueIs)('-')))), open$.pipe((0, utils_1.filterValue)(false), (0, utils_1.mapToConst)('close-dialog'))).pipe((0, operators_1.scan)(positive_points_reducer_1.pointsListReducer, (0, utils_1.IList)())));
    var positivePointsPixelPos$ = (0, utils_1.useDataStream)((0, utils_1.IList)(), (0, utils_1.combineLatestTyped)(positivePointsRelative$, croppedRectPixel$).pipe((0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), list = _b[0], outerRect = _b[1];
        return list.map((0, utils_1.toAbsolutePos)(outerRect)).map(utils_1.roundPosToInt);
    })));
    var negativePointsPixelPos$ = (0, utils_1.useDataStream)((0, utils_1.IList)(), (0, utils_1.combineLatestTyped)(negativePointsRelative$, croppedRectPixel$).pipe((0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), list = _b[0], outerRect = _b[1];
        return list.map((0, utils_1.toAbsolutePos)(outerRect)).map(utils_1.roundPosToInt);
    })));
    var cursorTypeOnCanvas$ = (0, utils_1.useDataStream)('default', plotMode$.pipe((0, operators_1.map)(function (mode) {
        switch (mode) {
            case '+':
            case '-':
                return 'crosshair';
            default:
                return 'default';
        }
    })));
    return {
        croppedRectPixel$: croppedRectPixel$,
        readonlyArea$: readonlyArea$,
        croppedRectAspectRatio$: croppedRectAspectRatio$,
        positivePointsRelative$: positivePointsRelative$,
        negativePointsRelative$: negativePointsRelative$,
        positivePointsPixelPos$: positivePointsPixelPos$,
        negativePointsPixelPos$: negativePointsPixelPos$,
        cursorTypeOnCanvas$: cursorTypeOnCanvas$
    };
};
exports.useStreams = useStreams;
